import React, { Component } from "react";
import PropTypes from "prop-types";
import { abrirEjercicio,addRecorridos, actualizaCargando, reseteaRecorrido } from "../js/actions/index";
import ModalEjercicio from "./Ejercicio";
import ModalVideo from "./ModalVideo";
import { ImagenSonda, ImagenEco } from "./ImageContext";
import Situar from "./Situar";
import { connect } from "react-redux"; 	
import Anatomia from "./Anatomia";
import Ecografia from "./Ecografia";
import caso from "../caso";
import "./simulador.scss";

function mapStateToProps(state){
	return {
		abordajeActual:state.exploracion.abordajeActual,
		casoActual:state.exploracion.casoActual,
		situar:state.situar,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		abrirEjercicio: (ejercicio) => dispatch(abrirEjercicio(ejercicio)),
		addRecorridos: (recorridos) => dispatch(addRecorridos(recorridos)),
		actualizaCargando: (progreso,mensaje) => dispatch(actualizaCargando({progreso,mensaje})),
		reseteaRecorrido: (inicial) => dispatch(reseteaRecorrido(inicial)),
	};
}

class SimuladorConnected extends Component{
	static propTypes = {
		abordajeActual:PropTypes.number,
		casoActual:PropTypes.number,
		situar:PropTypes.object,
		abrirEjercicio:PropTypes.func,
		addRecorridos:PropTypes.func,
		actualizaCargando:PropTypes.func,
		reseteaRecorrido:PropTypes.func,
	}
	
	sonda = [];
	eco = [];
	ruido = [];
	fondo = [];
	cargando = "";
	imagenesCargadas = 0;
	ejercicioActual = 0;
	abordaje = null;

	state={
		listo:false,
	}

	cargarImagenes = (numImagenes, listaImagenes, baseURL, extension, tipo) => {
		for(let i = 0; i <= numImagenes; i++){
			let numImagen = ""+i;
			if(i<10)numImagen = "0"+numImagen;
			if(i<100)numImagen = "0"+numImagen;
			listaImagenes[i] = new window.Image();
			listaImagenes[i].src = baseURL+numImagen+extension;
			listaImagenes[i].addEventListener("load", this.handleLoad);
			listaImagenes[i].addEventListener("error", (...args) => {console.error(args );});
		}
		this.imagenesCargadas = 0;
		this.props.actualizaCargando(this.imagenesCargadas*100/listaImagenes.length,"Cargar "+tipo+" "+this.imagenesCargadas+"/"+listaImagenes.length);
		this.cargando = tipo;
	}

	handleLoad = () => {
		this.imagenesCargadas++;
		this.abordaje = caso[this.props.casoActual].abordajes[this.props.abordajeActual];
		if(this.cargando === "sonda"){
			if(this.imagenesCargadas === this.sonda.length){
				this.cargarImagenes(10,this.ruido,"content/ruido/"+this.abordaje.ruido+"/"+this.abordaje.ruido+"_",".jpg","ruido");
			}else this.props.actualizaCargando(this.imagenesCargadas*100/this.sonda.length,"Cargar sonda "+this.imagenesCargadas+"/"+this.sonda.length);
		}else if(this.cargando === "ruido"){
			if(this.imagenesCargadas === this.ruido.length){
				let imgFin = this.abordaje.recorrido[this.abordaje.recorrido.length-1].finImg;
				this.cargarImagenes(imgFin,this.eco,"content/eco"+this.abordaje.ecografia+"/",".jpg","eco");
			}
			else this.props.actualizaCargando(this.imagenesCargadas*100/this.ruido.length,"Cargar ruido "+this.imagenesCargadas+"/"+this.ruido.length);
		}else if(this.cargando === "eco"){
			if(this.imagenesCargadas === this.eco.length){
				let cargaDinamico = false;
				let recorridos = caso[this.props.casoActual].abordajes[this.props.abordajeActual].recorrido;
				recorridos.forEach((recorrido)=>{
					if(recorrido.tipo === "din" && (!recorrido.mod || recorrido.mod !== "V")){
						this.cargarImagenes(
							recorrido.finImg-recorrido.iniImg,
							this.fondo,
							"content/anatomia"+caso[this.props.casoActual].abordajes[this.props.abordajeActual].fondo+"/",
							".jpg",
							"fondo"
						);
						cargaDinamico= true;
					}
				});
				if(!cargaDinamico){
					this.imagenesCargadas= 0;
					this.fondo[0] = new window.Image();
					this.fondo[0].src = "content/anatomia/"+caso[this.props.casoActual].abordajes[this.props.abordajeActual].fondo;
					this.fondo[0].addEventListener("load", this.handleLoad);
					this.fondo[0].addEventListener("error", (...args) => {console.error(args );});
					this.cargando = "fondo";
					this.props.actualizaCargando(0,"Cargar fondo ");
				}
			} else 
				this.props.actualizaCargando(this.imagenesCargadas*100/this.eco.length,"Cargar eco "+this.imagenesCargadas+"/"+this.eco.length);
		}else if(this.cargando === "fondo"){
			this.props.actualizaCargando(this.imagenesCargadas*100/this.fondo.length,"Cargar fondo "+this.imagenesCargadas+"/"+this.fondo.length);
			if(this.imagenesCargadas === this.fondo.length) this.setState({listo:true});
		}
	}
	
	componentDidMount(){
		this.cargarImagenes(180,this.sonda,"content/sonda/sonda0",".png","sonda");
	}

	render(){
		this.abordaje = caso[this.props.casoActual].abordajes[this.props.abordajeActual];
		let content = null;
		if(this.abordaje){
			if(this.props.situar.situar === "" || this.props.situar.situar !== this.abordaje.situar.opciones[this.abordaje.situar.valida]){
				content = 
					<Situar 
						valores={this.abordaje.situar} 
						baseURL="situar" 
						instruccion="seleccione la disposición correcta del ecógrafo"
						titulo="Disposición del ecógrafo"
						cabecera="Ecografista"
						caso={caso[this.props.casoActual].titulo}
						abordaje={this.abordaje.titulo}/>;
			}else if(this.props.situar.posicion === ""  || this.props.situar.posicion !== this.abordaje.anatomia.opciones[this.abordaje.anatomia.valida]){
				content = 
					<Situar 
						valores={this.abordaje.anatomia} 
						baseURL="posicion"
						instruccion="seleccione la posición del paciente"
						titulo="Posición del paciente"
						cabecera="Paciente"
						caso={caso[this.props.casoActual].titulo}
						abordaje={this.abordaje.titulo}/>;
			}else if(this.state.listo){
				if(this.abordaje != null){
					let ejercicio = {
						titulo:this.abordaje.titulo,
						texto:this.abordaje.ejercicio,
					};
					this.props.reseteaRecorrido({rot:this.abordaje.giro});
					this.props.addRecorridos(this.abordaje.recorrido);
					this.props.abrirEjercicio(ejercicio);
				}
				content = <>
					<header id="ejercicios">
						<h1>{caso[this.props.casoActual].titulo}</h1>
						<h2>{this.abordaje.titulo}</h2>
						<p><b>Ecografista:</b> {this.abordaje.situar.titulo}</p>
						<p><b>Paciente:</b> {this.abordaje.anatomia.titulo}</p>
						<p><b>Ejercicio:</b> {this.abordaje.ejercicio}</p>
					</header>
					<div className = "simulador">
						<ImagenSonda.Provider value={{sonda:this.sonda,fondo:this.fondo}}>
							<Anatomia/>
						</ImagenSonda.Provider>
						<ImagenEco.Provider value={{eco:this.eco,ruido:this.ruido}}>
							<Ecografia/>
						</ImagenEco.Provider>
					</div>
				</>;
			}
		}
		return (
			<>
				<ModalEjercicio/>
				<ModalVideo id="gel" video="aplicacion gel"/>
				<ModalVideo id="tutorial" video="tutorial"/>
				{content}
			</>
		);
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SimuladorConnected);